var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_36",
    "data-name": "Union 36",
    d: "M0,10A10,10,0,1,1,10,20,10.011,10.011,0,0,1,0,10Zm1.549,0A8.451,8.451,0,1,0,10,1.549,8.461,8.461,0,0,0,1.549,10Zm11.084,3.005-3.1-2.324a.773.773,0,0,1-.31-.62V5.414a.775.775,0,0,1,1.549,0v4.26l2.789,2.091a.775.775,0,1,1-.93,1.239Z",
    transform: "translate(0.001 -0.001)",
    fill: "#f38460"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b21dcf72df1177f3e8eacd4026acbd70.svg";
export { ForwardRef as ReactComponent };